export const POPUP_TYPES = {
  CART: "CART",
  MESSAGE: "MESSAGE",
  ACTION: "ACTION",
  ERROR: "ERROR"
};
